import KAvatar from '@components/k-avatar';
import RemoteStatusTag from '@components/remote-status-tag';

const columns = [
  {
    render: KAvatar,
    key: 'photo',
    width: 60,
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    key: 'phone',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Total Cases',
    dataIndex: 'total_cases',
    key: 'total_cases',
  },
  {
    title: 'Next Appointment',
    dataIndex: 'next_appointment',
    key: 'next_appointment',
  },
  {
    title: 'Status',
    key: 'status',
    render: ({ email }) => (
      <RemoteStatusTag collection="applicants" id={email} />
    ),
  },
];

const config = {
  columns,
};

export default config;
